function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.552 57.438l-3.883-3.254a3 3 0 01-.06-4.546l14.88-13.167c.646-.57 1.663-.113 1.663.75v6.59a1 1 0 001 1h27.497A5.351 5.351 0 0058 39.459v0-.891M19.364 63.987l3.146 2.636a1 1 0 001.642-.766v-6.668a1 1 0 011-1H61a7 7 0 007-7v-.58m-51.408 10.96l-1.512-1.267M60.448 14.562l3.883 3.254a3 3 0 01.06 4.546L49.511 35.53c-.646.57-1.663.113-1.663-.75v-6.59a1 1 0 00-1-1H18.851a5.351 5.351 0 00-5.351 5.352v.891M52.636 8.014L49.49 5.377a1 1 0 00-1.642.766v6.668a1 1 0 01-1 1H11a7 7 0 00-7 7v.58m51.408-10.96l1.512 1.267M42 65h12M34 65h3M30 6H18M38 6h-3",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeLinecap: "round"
});

function SvgTransactions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default __webpack_public_path__ + "/img/transactions.svg";
export { SvgTransactions as ReactComponent };